module.exports = __webpack_public_path__ + "img/banner_left.584c7d73.jpg";